module.exports = __webpack_public_path__ + "static/media/SCIcon_MiniSet.1027d794.png";